import { useTheme } from '@mui/material/styles'

const useTableStyles = () => {
    const theme = useTheme();
    return {
        selectFilter: {
            width:'6rem',
            height:'1.8rem',
            marginTop:1,
            backgroundColor: theme?.color?.background,
        },
        searchFilter: {
            height: "1.8rem",
            width: "8rem",
            marginTop:1,
            backgroundColor: theme?.color?.background,
            borderRadius: "4px",
            borderColor: theme?.color?.background,
            "& .MuiInputBase-root": {
                height: "1.8rem",
                width: "8rem",
              },
        },
        columnHeader: {
            whiteSpace:'nowrap',
            display:"flex",
            alignItems:"flex-start"
        },
        rowFilter: {
            "& .MuiInputBase-root": {
                height: "2rem",
            },
        },
        scrollbar: {
            cursor:"pointer",
        "&::-webkit-scrollbar": {
            width: "8px",
            height: "0.6rem",
            },
            "&::-webkit-scrollbar-track": {
            width: "8px",
            height: "1rem",
            backgroundColor: "#F8F8F8",
            },
            "&::-webkit-scrollbar-thumb": {
            backgroundColor:"#D8D8D8",
            borderRadius: "4px",
            },
        },
        rowImage: {
            height: "3rem",
            width: "5rem",
            objectFit: "fill",
        }
    }
};

export default useTableStyles;